var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadPage"},[_c('img',{attrs:{"src":require("@/assets/loading_logo.png")}}),_c('a-spin',{attrs:{"size":"large"}}),_c('div',[_vm._v("慧聪行业资源网")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }